<template>
   <div class="form-group">
      <label
         v-if="states != null"
         for="ip_state"
         :class="['label-overlay', { active: !isNotEmpty(form.state) }]"
         @click="switchLabel($event)"
         >{{ stateLabel }}</label
      >
      <select
         v-if="states != null"
         id="ip_state"
         v-model="form.state"
         :class="[
            'form-control custom-select',
            { 'is-invalid': isValidName.isInvalid },
            { 'is-valid': isValidName.isValid },
         ]"
         name="stateProv"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validatestateData();
            initiatedType();
         "
         @change="validatestateData()"
      >
         <option v-for="(option, index) in states" :key="index" :value="option.value">
            {{ option.text }}
         </option>
      </select>
      <input id="state_checkout" type="hidden" name="state_checkout" value="" />
      <div class="invalid-feedback">We want to know what the weather there is like.</div>
      <div class="valid-feedback">Looks good.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';
import $service from '../../../util/service.js';

export default {
   name: 'StateComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
   },
   data() {
      return {
         stateLabel: 'State',
         states: [],
         isValidName: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            state: this.value,
         },
         ...(process.browser && { tracker: this.$tracker.userProfile }),
         person,
      };
   },

   mounted() {
      this.getstates(this.form.state);

      /* if (this.person.profileData) {
         this.form.state = this.person.profileData.state || '';
      } */
   },
   methods: {
      validatestateData() {
         if (
            document.getElementById('state_checkout') != null &&
            document.getElementById('ip_state') != null
         ) {
            document.getElementById('state_checkout').value = document.getElementById(
               'ip_state'
            ).options[document.getElementById('ip_state').selectedIndex].text;
         }
         this.isValidName.isValid = !this.isNotEmpty(this.form.state);
         this.isValidName.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.state);

         this.$emit('StateChanged', {
            key: this.form.country,
         });
      },
      initiatedType() {
         if (this.form.state !== '') this.tracker.information({ state: this.form.state });
      },

      async getstates(con) {
         try {
            if (con === 'US') {
               const list = await $service.get('/data/statesUS');
               this.states = list.data;
               this.stateLabel = 'State';
            } else if (con === 'CA') {
               this.stateLabel = 'Province';
               const list = await $service.get('/data/statesCA');
               this.states = list.data;
            } else {
               this.stateLabel = 'State';
               this.states = null;
            }
         } catch (error) {
            // eslint-disable-next-line
            console.warn('Fetching error' + error);
         }
      },
   },
};
</script>
